module.exports = __webpack_public_path__ + "static/media/assistive-listening-systems.99877dc7.svg";